export const getSavedProducts = state => state.savedItems.savedProducts;

export const isProductSaved = (state, productId) =>
  getSavedProducts(state).includes(productId);
